import styled from 'styled-components';
import device from '../../mediaQueries';

const EmptySectionMessage = styled.div`
  text-align: center;
  ${device.mobile`
    padding-top: 21px
    width: 100%;
  `}
  ${device.desktop`
    width: 75%
  `}
`;

export default EmptySectionMessage;
